export default function getClearingTranslatedStatus(status, time_diff){
    if (status === "open") return "Offen";
    else if (status === "closed") return "Abgeschlossen";
    else if (status === "processing") return "In Bearbeitung";
    else if (status === "overdue") return "Überfällig";
    else return status;
}

